<template>
    <div id="search-input" :style="divStyle">
        <input type="text" :class="inputClass" :style="inputStyle" v-model="search" placeholder="Search" @focus="search=''; data={}" />
        <div id="list">
            <ul>
                <li @click="data=''" style="height:1em">
                </li>
                <li v-for="(value, index) in list" :key="index" @click="data=value;search=value[field]">
                    {{value[field]}}<span v-if="field2"> - {{value[field2]}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import {mapActions} from 'vuex'
export default {
  name: 'search-input',
  components: {},
  props: ['inputStyle', 'inputClass', 'url', 'divStyle', 'field', 'field2', 'source', 'searchField'],
  created () {
    this.debouncedGetAnswer = _.debounce(this.loadList, 500)
  },
  mounted () {
    this.loadList()
  },
  watch: {
    data () {
      this.$emit('data', this.data)
    },
    search () {
      this.debouncedGetAnswer()
    },
    source (newVal) {
      if (!newVal) {
        this.search = ''
      }
    }
  },
  data () {
    return {
      data: {},
      search: '',
      list: []
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      getList: 'bi/listes'
    }),
    loadList () {
      this.getList({url: this.url, params: {ordering: this.field, [this.searchField]: this.search}}).then((response) => {
        this.list = response
      })
    },
    checkchanges () {
      if (this.data && this.data.id) {
        this.data = {}
        this.search = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
#search-input{
    position: relative;
}
input{
    width: 100%;
}
input:focus + #list{
    visibility: visible;
    opacity: 1;
}
#list{
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.2s, opacity 0.2s ease-out;
    position: absolute;
    width: 100%;
    border: 2px solid #CCCCCC;
    border-bottom-left-radius: .6em;
    border-bottom-right-radius: .6em;
    overflow: auto;
    max-height: 10em;
    background: white;
    box-sizing: border-box;
    z-index: 1000;
}
ul{
    margin: .2em;
    list-style: none;
    background: white;
    color:#088aab;
}
li{
    padding: .1em .5em;
    border-radius: .4em;
    transition: all 0.1s;
    cursor: pointer;
    &:hover{
        background: rgb(181, 238, 255);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchCombo.vue